
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import EuButton from '../Button/Button.vue';
import EuGeneralFeatureCard from '../GeneralFeatureCard/GeneralFeatureCard.vue';
/**
- To modify the max-width of the text inside the card, use class <b>.eu-generaldescriptioncard .content</b>
- To modify the image inside the card, use class <b>.eu-generaldescriptioncard .eu-content-image</b>
- To show text content with list, simply put array list inside <b>content</b> as it accepts either string / array form.
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralDescriptionCard',
  components: {
    EuCard,
    EuButton,
    EuGeneralFeatureCard
  },
  data() {
    return {
      expand: false
    };
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set header text
     */
    header: {
      type: String,
      default: ''
    },
    /**
     * Set list of desc
     */
    list: {
      type: Array,
      default: () => []
    },
    /**
     * Set Expand Button
     */
    expandLabel: {
      type: String,
      default: ''
    },
    /**
     * Set See View Button
     */
    closeLabel: {
      type: String,
      default: ''
    },
    /**
     * Set default length shown
     */
    defaultLength: {
      type: Number,
      default: 2
    }
  },
  computed: {
    isExpandLength() {
      //the length that will show the expand label
      return this.list.length > this.defaultLength;
    },
    computedButtonLabel() {
      if (this.isExpandLength) {
        if (this.expand) {
          return this.closeLabel;
        }
        return this.expandLabel;
      }
      return '';
    },
    containerHeight() {
      return {
        expand: this.expand,
        first: !this.expand
      };
    },
    computedList() {
      // if expanded, show all list
      if (this.expand || !this.isExpandLength) {
        return this.list;
      }
      // if not, show in amount of defaultLength given
      return this.list.slice(0, this.defaultLength);
    }
  },
  methods: {
    handleClick(e: any) {
      this.expand = !this.expand;
      /**
       * On click expand button
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
